import { render, staticRenderFns } from "./redeem.vue?vue&type=template&id=2f9edb2c&scoped=true&"
import script from "./redeem.vue?vue&type=script&lang=js&"
export * from "./redeem.vue?vue&type=script&lang=js&"
import style0 from "./redeem.vue?vue&type=style&index=0&id=2f9edb2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9edb2c",
  null
  
)

component.options.__file = "redeem.vue"
export default component.exports